/**
 * @Author: Nenad Brcic
 * @Date: 19.09.16
 * @Email: neno@neno.ch
 */

import React, { PropTypes } from 'react';
import ArrowLink from '../../shared/ArrowLink';
import { getCurrentLanguage } from '../../../localData';

const NavigationItem = ({ name, icon, url, handleClick}) => (
    <li onClick={ handleClick }>
        <ArrowLink text={ name } icon={ icon } url={ `/${getCurrentLanguage()}${url}` } />
    </li>
);

NavigationItem.propTypes = {
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    handleClick: PropTypes.func.isRequired,
    icon: PropTypes.string,
};

export default NavigationItem;


// WEBPACK FOOTER //
// ./app/components/Main/Navigation/NavigationItem.jsx